import RenderInfo from 'components/RenderInfo';
import React from 'react';
import styles from './index.module.scss';

const BasicDetails = (props) => {
  const { details: { name = '', enName = '', description = '', enDescription = '', objectId = '', active = false, price = 0, priceId = '' } = {}} = props;

  return <div className={styles['details-section']}>
    <div className={styles['info-container']}>
      <div className={styles['info']}>
        <RenderInfo heading="ID" value={objectId} />
        <RenderInfo heading="Name" value={name} />
        <RenderInfo heading="Description" value={description} />
        <RenderInfo heading="Price" value={price/100} type="currency" />
      </div>
      <div className={styles['info']}>
        <RenderInfo heading="Active" value={active} type='boolean' />
        <RenderInfo heading="English Name" value={enName} />
        <RenderInfo heading="English Description" value={enDescription} />
        <RenderInfo heading="Stripe price id" value={priceId} />
      </div>
    </div>
  </div>;
};

export default BasicDetails;